import { useState } from 'react';
import { KPODataFetchWrapper } from '../wrappers/KPODataFetchWrapper';
import { DataFetchFunction } from '../types/ProgressTypes';
import { EupType } from "../../model";

export const useKpoListData = (onComplete?: () => void) => {
    const [showProgress, setShowProgress] = useState(false);
    const [fetchDataFunction, setFetchDataFunction] = useState<DataFetchFunction | null>(null);

    const fetchKpoListData = (
        eupType: EupType,
        year: number,
        sheetName: string,
    ) => {
        const dataFetch = KPODataFetchWrapper.wrapKpoStatusOverviewDataFetch(
            eupType,
            year,
            sheetName,
        );
        setFetchDataFunction(() => dataFetch);
        setShowProgress(true);
    };

    const resetProgress = () => {
        setShowProgress(false);
        setFetchDataFunction(null);
    };

    const handleProgressComplete = (wasSuccess: boolean) => {
        resetProgress();
        // Wywołaj callback przekazany z komponentu rodzica tylko przy sukcesie
        if (wasSuccess && onComplete) {
            onComplete();
        }
    };

    return {
        showProgress,
        fetchDataFunction,
        fetchKpoListData,
        resetProgress,
        handleProgressComplete,
        backTo: '/' // Nie jest już używany, ale zachowany dla kompatybilności
    };
};